// import * as S from 'sanctuary';
import { isValid, addDays, } from 'date-fns';

// import {startOfMonth, startOfWeek} from 'date-fns';
import { addDaysUTC, resetHourOfUTCDate, startOfMonth, startOfWeek } from './calendar';
import { HttpLib } from "../services/http/http-lib";

import {
  ifElse, isNil, identity, compose, join, juxt,
  toUpper, head, tail, and, lte, range, is, isEmpty, zip, pipe,
  toPairs, sortBy, prop, map, fromPairs, flatten,
} from 'ramda';
import * as qs from 'querystring';
import { split } from 'ramda';


export * from './async';
export * from './clipboard';
export * from './errors';
export * from './encoder';
export * from './validator';
export * from './color';
export * from './jsonx';
export * from './inspect';
export * from './rxx';
export * from './string';
export * from './number';
export * from './responsive';
export * from './types';

/** Creates an UUID version4 */
export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/** Create a MailTo Href from the arguments */
export function createMailHref({
  subject,
  body,
  mails = []
}) {
  return `mailto:${mails?.join(',')
    }?${qs.stringify({
      subject,
      body
    })}`;
};

/** Opens a link in a new tab */

export const openNewTab = (url) => {
  window.open(url, '_blank');
}

export const sendMailHref = ({
  subject,
  body,
  mails = []
}) => {
  const mailLink = createMailHref({
    subject,
    body,
    mails
  });
  location.href = mailLink
}
export const sendMailNewTab = ({
  subject,
  body,
  mails = []
}) => {
  const mailLink = createMailHref({
    subject,
    body,
    mails
  });
  openMailWindow(mailLink);
}

/** Opens a Mail window in a new window */
export const openMailWindow = (mailToLink) => {
  window.open(
    mailToLink,
    '_blank'
  );
}

// Open a window
export const openWindow = (url, title, { h = 0, w = 0, wr = 0.5, hr = 0.5 }) => {

  // Fixes dual-screen position                             Most browsers      Firefox
  const allScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const allScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const finalWidth = window?.screen?.availWidth ? window?.screen?.availWidth : width;
  const finalHeight = window?.screen?.availHeight ? window?.screen?.availHeight : height;

  w = w > 0 ? w : finalWidth * wr;
  h = h > 0 ? h : finalHeight * hr;

  const xOffset = allScreenLeft > finalWidth ? finalWidth : 0;
  const yOffset = allScreenTop > finalHeight ? finalHeight : 0;

  const left = (finalWidth - w) / 2 + xOffset;
  const top = (finalHeight - h) / 2 + yOffset;

  return window.open(url, 'title',
    `
      width=${w}, 
      height=${h}, 
      top=${top}, 
      left=${left}
      `
  );
}

// Download a File By Creating Link
export const downloadFile = url => {
  const tempLink = document.createElement('a');
  // tempLink.target = '_blank';
  tempLink.href = url;
  tempLink.click();
  tempLink.remove();
}

export const getCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  console.log('decodedCookie',decodedCookie)
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Given url web page download as a pdf file using pdf.berlin3.com server with ext_api.
export const downloadPDF = async (url, account, filename) => {
  const { client: { clientID }, ext_api_checksum, ...rest } = account;

  // const cookies = "DISKO::AUTH_berlin3=safiqul:2023-09-18-07-43-31:2023-09-20-07-43-31::31ee2c27a8f92d89b58453e41416538c";
  const cookies = `DISKO::AUTH_berlin3=${getCookie('DISKO::AUTH_berlin3')}`;
  const checksum = ext_api_checksum || '6a79f835914613281b09bf812024fb24';
  const endpoint = rest?.pdf_endpoint || 'https://pdf.berlin3.com/api/';
  const client_id = clientID || 'berlin3';

  let downloadURL = `${endpoint}${client_id}/?action=htmltopdf&api_key=${checksum}&set_cookie=1&cookies=${encodeURIComponent(cookies)}&html_url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`;
  
  // Replace %3F or %3f with ?
  // To fix the apache error -- AH: Unsafe URL with %3f URL rewritten without UnsafeAllow3F
  downloadURL = downloadURL.replace(/%3f/gi, '?');
  
  console.log("mdsir: downloadURL", downloadURL);
  // downloadFile(downloadURL);

  const response = await HttpLib.get(downloadURL, {
    responseType: 'blob',
  });

  // create file link in browser's memory
  const href = URL.createObjectURL(response.data);

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

// Open mail window by passing the href object
export const sendMail = ({
  subject,
  body,
  mails = []
}) => {
  openMailWindow(createMailHref({
    subject,
    body,
    mails
  }));
}

/** Execute asynchronous code waiting for the animation. Average time is 200 ms */
export function waitForAnimation(f, delay = 200) {
  setTimeout(f, delay);
}

/** Execute asynchronous code waiting for the animation. Average time is 200 ms */
export function waitForBackend(f, delay = 500) {
  setTimeout(f, delay);
}

/** Wait by the milliseconds time. */
export const wait = (time = 1) => {
  return new Promise(resolve => setTimeout(resolve, time));
}

/** Capitalize the first letter of the word */
export const capitalizeFirst = ifElse(
  isNil,
  identity,
  compose(
    join(''),
    juxt([compose(toUpper, head), tail])
  )
);

/** Capitalize the First letter of each words in the passed in string */
export const capitalizeWords = (string, splitter = ' ') => string.split(splitter).map(capitalizeFirst).join(splitter);

// export const capSnake = (string, splitter = '_', joiner = ' ') => string.split(splitter).map(capitalizeFirst).join(joiner);

export const capSnake = (string, splitter = '_', joiner = ' ') => ifElse(isNil, identity, pipe(split(splitter), map(capitalizeFirst), join(joiner)))(string);
// string.split(splitter).map(capitalizeFirst).join(joiner);




/** Log the value - useful in tracing piped functions */
export const trace = (v) => {
  console.log(v);
  return v;
}

/** Add & removes from the Set */
export const addRemoveSet = (operation = true, inputSet = new Set(), selected) => {
  // console.log("Log: addRemoveSet -> set", Array.from(set))
  const set = new Set(inputSet);

  if (operation === true) {
    if (!set.has(selected)) {
      set.add(selected);
      // console.log("Log: addRemoveSet -> set -> add", set)
    }
  } else if (operation === false) {
    if (set.has(selected)) {
      set.delete(selected);
      // console.log("Log: addRemoveSet -> set -> delete", set)
    }
  } else if (operation === 'toggle') {
    if (!set.has(selected)) {
      set.add(selected);
    } else {
      set.delete(selected);
    }
  }
  // console.log("Log: addRemoveSet -> set -> return", set)
  return Object.freeze(set);
}


const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export function formatBytes(x) {
  let l = 0;
  let n = parseInt(x, 10) || 0;
  while (n >= 1024 && ++l)
    n = n / 1024;
  return (`${n.toFixed(n >= 10 || l < 1 ? 0 : 1)} ${units[l]}`);
}


export const preventAndStop = (event) => {
  if (!event) {
    return;
  }

  if (event.preventDefault) {
    event.preventDefault();
  }
  if (event.stopPropagation) {
    event.stopPropagation();
  }
}

export const validPositiveNumber = and(e => !isNaN(e), lte(0));


/** Returns the absolute position of the element relative to the document */
export function offset(el) {
  const rect = el.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

// const a = [12,31231,23,12,312,423,412];

// console.log(S.head ([]));


export const startOfCalendar = (date, option = {}) =>
  startOfWeek(startOfMonth(date), option);


export const getCalendarGrid = (date, options = {
  weekStartsOn: 1,
  dayPerWeek: 7,
  weekCount: 6
}) => {
  if (!isValid(date)) {
    throw Error('Please pass a valid starting Date');
  }
  let start = startOfCalendar(date, {
    weekStartsOn: options.weekStartsOn
  });
  console.log({ "Calendar Start": start, date });
  return range(1, options.weekCount + 1).map(w => {
    return range(1, options.dayPerWeek + 1).map(d => {
      const temp = new Date(start);
      // start = addDays(start, 1);
      start = resetHourOfUTCDate(addDaysUTC(temp, 1));
      console.log({
        'index.js:303 new Day': start,
        temp,
        a1: addDaysUTC(temp, 1),
        rh: resetHourOfUTCDate(addDaysUTC(temp, 1))
      });
      return temp;
    });
  });
};


export const atMost = (value, atMost = Number.MAX_SAFE_INTEGER,) => {
  if (value < atMost) {
    return value;
  }
  return atMost;
}

export const within = (max = Number.MAX_SAFE_INTEGER, min = Number.MIN_SAFE_INTEGER, value, defaultValue = 0) => {
  if (value < max && value > min) {
    return value;
  } else if (value >= max) {
    return max;
  } else if (value <= min) {
    return min;
  } else {
    return defaultValue;
  }
}

function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function invertColor(hex, bw) {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 145
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

export const toSnakeCase = (string) => {
  return string && string.replace(/([A-Z])/g, e => `_${e.toLowerCase()}`)
}

export const sentenceToSnakeCase = string => {
  return string && string.replace(/ /g, '_');
}

export const sentenceToLowerSnakeCase = string => {
  return string && string.replace(/ /g, '_').toLowerCase();
}

export const snakeCaseToWords = (string) => {
  if (!string) {
    return '';
  }
  return string.replace(/_([a-z])/g, " $1").split(' ').map(e => {
    return head(e).toUpperCase() + e.slice(1);
  }).join(' ')
}

/** Turns snake case into Camel Case */
export const snakeToCamelCase = (string) => {
  if (!string) {
    return '';
  }
  return string.replace(/_(\w)/g, (head) => {
    return head[1].toUpperCase();
  });
};

export const isNotEmptyString = (string) => {
  string = string && string.toString();
  return is(String, string) && !isEmpty(string);
}


// Google Maps Marker and Info Window Functions

const markerInfoWindows = 'markerInfoWindows';
export const registerMarkerAndInfoWindow = (component, map, markers, infoWindows, bounceAnimation) => {

  component[markerInfoWindows] = zip(markers, infoWindows);

  component[markerInfoWindows].map(([marker, infoWindow]) => {
    marker.addListener('click', e => {

      toggleBounce(component, map, marker, infoWindow, bounceAnimation)
    });
    infoWindow.addListener('click', e => {
      console.log("infoWindow", infoWindow)
    })

  });
}

// Add Event listener to the markers
export const toggleBounce = (component, map, marker, infoWindow, bounceAnimation) => {
  infoWindow.open(map, marker);

  component[markerInfoWindows].map(([mk, iw]) => {
    if (iw != infoWindow) {
      iw.close();
    }
    if (mk !== marker) {
      mk.setAnimation(null);
    }
  });

  if (marker.getAnimation() !== null) {
    marker.setAnimation(null);
  } else {
    marker.setAnimation(bounceAnimation);
  }
}


export const getScrollDimensionY = (element) => {
  const height = element.getBoundingClientRect().height;
  const scrollHeight = element.scrollHeight;
  const scrollTop = element.scrollTop;

  return {
    height,
    scrollHeight,
    scrollTop,
    get maxScrollTop() {
      return scrollHeight - height;
    },
    get scrollPercent() {
      return scrollTop / (scrollHeight - height) * 100;
    }
  };
}
export function setInputTimer(domElm, callback) {
  let lastTime = new Date().getTime();
  domElm.setAttribute("last-edited", lastTime);
  let timeOutId = domElm.getAttribute("timeout-id");
  if (timeOutId) {
    clearTimeout(timeOutId);
  }
  timeOutId = setTimeout(callback, 300);
  domElm.setAttribute("timeout-id", timeOutId);
}
// Return the Dropdown options from full data (arrayOfObjects)
export const getDropdownOptions = (arrayOfObjects, textProperty, valueProperty) => {
  return arrayOfObjects
    ? arrayOfObjects.map(e => ({
      text: e[textProperty],
      value: e[valueProperty]
    }))
    : [];
}

/** Sort the object by the keys */
export const sortObject = pipe(toPairs, sortBy(prop('0')), map(([key, value]) => {
  if (is(Object, value) && !is(Array, value)) {
    return [key, sortObject(value)];
  } else {
    return [key, value];
  }
}), fromPairs);


/** Debounce the function by wait milliseconds. Third argument for immediate execution  */
export function debounceFunction(func, wait = 50, immediate) {
  let timeout;
  return function () {
    let context = this, args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};


/** The List of Alphabet Letters. Pass in case as argument to get specific case Alphabet */
export const getAlphabet = (letter_case = 'both') => {
  if (letter_case === 'both') {
    return flatten('abcdefghijklmnopqrstuvwxyz'.split('').map(s => [s.toLowerCase(), s.toUpperCase()]));
  } else if (letter_case === 'lower') {
    return 'abcdefghijklmnopqrstuvwxyz'.split('').map(s => s.toLowerCase());
  } else if (letter_case === 'upper') {
    return 'abcdefghijklmnopqrstuvwxyz'.split('').map(s => s.toUpperCase());
  }
}


/** Convert HTML To String */
export const htmlToString = (html) => {
  return html.replace(/<[^>]+>/g, '');
  // const htmlElement = document.createElement("b");
  // htmlElement.innerHTML = html;
  // return htmlElement.innerText;
}

/** Opens Window in the middle of the screen */
export const popupCenter = ({ url, title, w, h }) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft
  const top = (height - h) / 2 / systemZoom + dualScreenTop
  const newWindow = window.open(url, title,
    `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
  )

  if (window.focus) newWindow.focus();
}


/** Returns true if the passed in Event is an Enter Key. Usually Used in KeyUp Events  */
export function isEnterKey(event) {
  if (event && event.keyCode == 13) {
    return true;
  } else {
    return false;
  }
}


/** Checks if the Value is indeed a valid Number - Not a NaN */
export const isValidNumber = value => {
  value = +value;
  if (typeof value === 'number') {
    if (!isNaN(value)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}



export const getTimeNumber = () => {
  return (new Date()).getTime();
}

// Checks the Equality of 2 Arrays
export function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

/**
 * Checks if a DOM element is overflown
 */
export const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) => {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
}

export const getNoteRow = (str) => {
  return str.split('\n').length
}

// Checks if the passed in value is a Number of String 1
export const isChecked = (value) => {
  return value === 1 || value === '1';
}

window.addRemoveSet = addRemoveSet;



// Get Browser Name and Version

export const getDeviceInfo = () => {
  let userAgent = navigator.userAgent;
  let browserName, browserVersion;

  // Get Operatin System
  let operatingSystem = navigator.platform || 'unknown operating system';


  // Get Screen Resolution
  let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  let screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  let screenResolution = screenWidth + 'x' + screenHeight;

  let adjustedResolution = screenWidth / window.devicePixelRatio + 'x' + screenHeight / window.devicePixelRatio;

  let screenInfo = `${screenResolution}_DPR_${devicePixelRatio}_AR_(${adjustedResolution})`


  if (/opera|opr/i.test(userAgent)) {
    browserName = 'Opera';
    browserVersion = userAgent.match(/(opera|opr)[\s\/:]([\w\d.-]+)/i)[2];
  } else if (/edg/i.test(userAgent)) {
    browserName = 'Microsoft Edge';
    browserVersion = userAgent.match(/edg(?:e|a|ios|ium)?\/([\d.]+)/i)[1];
  } else if (/chrome|crios/i.test(userAgent)) {
    browserName = 'Google Chrome';
    browserVersion = userAgent.match(/(?:chrome|crios)\/([\d.]+)/i)[1];
  } else if (/safari/i.test(userAgent)) {
    browserName = 'Safari';
    browserVersion = userAgent.match(/version\/([\d.]+)/i)[1];
  } else if (/firefox|fxios/i.test(userAgent)) {
    browserName = 'Mozilla Firefox';
    browserVersion = userAgent.match(/(?:firefox|fxios)\/([\d.]+)/i)[1];
  } else if (/msie|trident/i.test(userAgent)) {
    browserName = 'Internet Explorer';
    browserVersion = userAgent.match(/(?:msie |rv:)(\d+(\.\d+)?)/i)[1];
  } else {
    browserName = 'Unknown Browser';
    browserVersion = 'N/A';
  }
  return {
    userAgent,
    browserName,
    browserVersion,
    operatingSystem,
    screenResolution,
    adjustedResolution,
    screenInfo,
  }
}


export function getUTCTimeOffset() {
  const date = new Date();
  const timezoneOffset = date.getTimezoneOffset();

  // Calculate the UTC+ offset
  const hoursOffset = Math.floor(Math.abs(timezoneOffset / 60));
  const minutesOffset = Math.abs(timezoneOffset % 60);
  const offsetSign = timezoneOffset < 0 ? '+' : '-';

  // Format the UTC+ offset as a string
  const offsetString = `${offsetSign}${padZero(hoursOffset)}:${padZero(minutesOffset)}`;

  return offsetString;
}



export const getPerformanceMemoryInfo = () => {
  if (performance && performance.memory) {
    const memoryInfo = performance.memory;

    // Total Memory
    const totalMemory = memoryInfo.totalJSHeapSize;

    // Used Memory
    const usedMemory = memoryInfo.usedJSHeapSize;

    // Free Memory
    const freeMemory = totalMemory - usedMemory;

    return `${(usedMemory / (1000 * 1000)).toFixed(2)} MB /${(totalMemory / (1000 * 1000)).toFixed(2)} MB`
  } else {
    return `Unavailable`;
  }
}

export function sanitizeFilename(filename = "Filename") {
  return filename
    .replace(/</g, '')
    .replace(/>/g, '')
    .replace(/:/g, '')
    .replace(/"/g, '')
    .replace(/\//g, '')
    .replace(/\\/g, '')
    .replace(/\|/g, '')
    .replace(/\?/g, '')
    .replace(/\*/g, '');
}


export const dropDownListHeightCalculate = (tvArray=[],height=32)=>{

  return tvArray.length*height

}
